// extracted by mini-css-extract-plugin
export var copyableField = "_nr-4";
export var customerBadge = "_nr-0";
export var customerInfoTitle = "_nr-2";
export var details = "_nr-1";
export var dropdownContainer = "_nr-5";
export var dropdownImage = "_nr-6";
export var editAssigneeForm = "_nr-a";
export var editButton = "_nr-3";
export var email = "_nr-7";
export var hidden = "_nr-d";
export var input = "_nr-8";
export var saveButton = "_nr-b";
export var shopifyIcon = "_nr-c";
export var suggestionBadge = "_nr-e";
export var suggestionText = "_nr-f";
export var username = "_nr-9";